// Sync Day.js global locale to your app’s active locale.
// Add a new language here with one import + one map entry.

import dayjs from 'dayjs';
import LocaleManager from '@/i12e/i18n/localeManager';
import 'dayjs/locale/en';
import 'dayjs/locale/es';

let listenerAttached = false;

export default {
  install: () => {
    // Set initial locale
    dayjs.locale(LocaleManager.activeLocale);

    // Only attach our handler a single time
    if (listenerAttached) return;
    // Update Day.js when locale changes
    LocaleManager.addEventListener('locale-changed', () => {
      dayjs.locale(LocaleManager.activeLocale);
    });
    listenerAttached = true;
  }
};
